(function () {
  function initKcbc(root) {
    if (!root || root.dataset.kcbcBound === 'true') return;
    root.dataset.kcbcBound = 'true';
    
      
      

      const viewport = root.querySelector('[data-kcbc-viewport]');
      const track = root.querySelector('[data-kcbc-track]');
      const prevBtn = root.querySelector('.kcbc__nav--prev');
      const nextBtn = root.querySelector('.kcbc__nav--next');
      const dotsWrap = root.querySelector('[data-kcbc-dots]');
      if (!viewport || !track) return;

      const slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      let dots = [];

      function safeJson(sel){
        const el = root.querySelector(sel);
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch(e){ return null; }
      }

      const i18n = safeJson('[data-kcbc-i18n]') || {};
      const hatVariants = safeJson('[data-kcbc-variants-hat]') || [];
      const kitVariants = safeJson('[data-kcbc-variants-kit]') || [];
      const hatSw = (safeJson('[data-kcbc-swatches-hat]') || {}).items || [];
      const kitSw = (safeJson('[data-kcbc-swatches-kit]') || {}).items || [];

      // Locale-aware cart URL so adding a bundle never flips the site language.
      const KCBC_CART_URL = (root.dataset.kcbcCartUrl || '/cart');
      // Normalize so a swatch value matches the variant option even if apostrophes
      // (curly vs straight), case or spacing differ — e.g. "Rêve d’azur" vs "Rêve d'azur".
      function kcNorm(s){
        return (s == null ? '' : String(s))
          .trim()
          .toLowerCase()
          .replace(/[‘’ʼ]/g, "'")
          .replace(/\s+/g, ' ');
      }

      function getStep() {
        if (slides.length < 2) return viewport.clientWidth;
        const a = slides[0].getBoundingClientRect();
        const b = slides[1].getBoundingClientRect();
        return Math.abs(b.left - a.left) || viewport.clientWidth;
      }

      function getIndex() {
        const step = getStep();
        return Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / step)));
      }

      function scrollToIndex(index) {
        const step = getStep();
        viewport.scrollTo({ left: Math.max(0, Math.min(index, slides.length - 1)) * step, behavior: 'smooth' });
      }

      function updateUI() {
        const index = getIndex();
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= slides.length - 1;

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        dots = slides.map(function (_, i) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'kcbc__dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', (i18n.goToBundle || 'Go to bundle') + ' ' + (i + 1));
          b.addEventListener('click', function () { scrollToIndex(i); });
          dotsWrap.appendChild(b);
          return b;
        });
      }

      let scrollTimer;
      viewport.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateUI, 60);
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(getIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(getIndex() + 1); });

      window.addEventListener('resize', updateUI);
      buildDots();
      updateUI();

      function closeCard(card){
        const btn = card.querySelector('[data-kcbc-toggle]');
        const details = card.querySelector('[data-kcbc-details]');
        const label = card.querySelector('.kcbc__toggle-label');
        if (!btn || !details) return;
        card.classList.remove('is-open');
        btn.setAttribute('aria-expanded','false');
        if (label) label.textContent = i18n.expandLabel || '';
        details.hidden = true;
      }

      function openCard(card){
        const btn = card.querySelector('[data-kcbc-toggle]');
        const details = card.querySelector('[data-kcbc-details]');
        const label = card.querySelector('.kcbc__toggle-label');
        if (!btn || !details) return;

        root.querySelectorAll('.kcbc__card.is-open').forEach(function(c){
          if (c !== card) closeCard(c);
        });

        card.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
        if (label) label.textContent = i18n.collapseLabel || '';
        details.hidden = false;
      }

      root.addEventListener('click', function(e){
        const toggle = e.target.closest('[data-kcbc-toggle]');
        if (toggle){
          const card = toggle.closest('.kcbc__card');
          if (!card) return;
          if (card.classList.contains('is-open')) closeCard(card);
          else openCard(card);
        }
      });

      function buildMap(variants){
        const map = {};
        variants.forEach(function(v){
          if (!v || !v.option1) return;
          const key = kcNorm(v.option1);
          if (!map[key]) map[key] = v.id;
        });
        return map;
      }

      const mapHat = buildMap(hatVariants);
      const mapKit = buildMap(kitVariants);

      // BUGFIX: swatch values are authored in FR in the theme settings, but on
      // /en pages Shopify serves TRANSLATED variant option names ("Jardin
      // secret" -> "Secret garden"), so the name-based map missed 3 of 4
      // patterns and the bundle refused to add for English visitors.
      // Fallback: map by swatch position - settings order mirrors variant order.
      function resolveVariantId(productKey, normVal){
        const map = productKey === 'hat' ? mapHat : mapKit;
        if (map[normVal]) return map[normVal];
        const items = productKey === 'hat' ? hatSw : kitSw;
        const variants = productKey === 'hat' ? hatVariants : kitVariants;
        for (let i = 0; i < items.length; i++){
          if (items[i] && kcNorm(items[i].value) === normVal){
            if (variants[i] && variants[i].id) return variants[i].id;
            break;
          }
        }
        return null;
      }

      function getDefaultValue(items){
        for (let i = 0; i < items.length; i++){
          if (items[i] && items[i].value) return items[i].value;
        }
        return null;
      }

      function setActiveSwatch(swWrap, value){
        swWrap.querySelectorAll('.kcbc__swatch').forEach(function(btn){
          const isOn = btn.getAttribute('data-swatch-value') === value;
          btn.classList.toggle('is-active', isOn);
          btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        });
      }

      function renderSwatches(container, items){
        if (!container) return;
        const frag = document.createDocumentFragment();

        items.forEach(function(item){
          if (!item || !item.value) return;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kcbc__swatch';
          btn.setAttribute('data-swatch-value', item.value);
          btn.setAttribute('aria-pressed', 'false');

          const labelText = item.label || item.value;
          btn.setAttribute('title', labelText);
          btn.setAttribute('aria-label', labelText);

          const imgWrap = document.createElement('span');
          imgWrap.className = 'kcbc__swatch-img';

          if (item.img) {
            const im = document.createElement('img');
            im.loading = 'lazy';
            im.alt = labelText;
            im.src = item.img;
            imgWrap.appendChild(im);
          }

          const check = document.createElement('span');
          check.className = 'kcbc__swatch-check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';

          btn.appendChild(imgWrap);
          btn.appendChild(check);
          frag.appendChild(btn);
        });

        container.innerHTML = '';
        container.appendChild(frag);
      }

      function collectItems(slide){
        const slots = slide.querySelectorAll('.kcbc__slot');
        const items = [];
        let unresolved = 0;

        slots.forEach(function(slot){
          const swWrap = slot.querySelector('.kcbc__swatches');
          if (!swWrap) return;

          const productKey = swWrap.getAttribute('data-product');
          const val = kcNorm(swWrap.getAttribute('data-selected'));

          const vid = resolveVariantId(productKey, val);

          if (vid) items.push({ id: Number(vid), quantity: 1 });
          else unresolved++;   // a slot we couldn't match → never add a partial bundle
        });

        return { items: items, unresolved: unresolved };
      }

      function buildCheckoutUrl(items){
        if (!items.length) return null;
        // Locale-aware base so Buy Now keeps the current language.
        let url = KCBC_CART_URL + '/' + items.map(function(item){
          return item.id + ':' + item.quantity;
        }).join(',');
        url += '?checkout';
        return url;
      }

      function openCartUI(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:open'));

        const drawerTrigger =
          document.getElementById('cart-icon-bubble') ||
          document.querySelector('[data-cart-open]') ||
          document.querySelector('[aria-controls*="Cart"]') ||
          document.querySelector('a[href$="/cart"]');

        if (drawerTrigger && typeof drawerTrigger.click === 'function') {
          try {
            drawerTrigger.click();
            return;
          } catch(e){}
        }

        // Locale-aware fallback so we never flip the site to the default language.
        window.location.href = KCBC_CART_URL;
      }

      function addItemsAjax(items){
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        }).then(function(res){
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        });
      }

      slides.forEach(function(slide){
        slide.querySelectorAll('.kcbc__swatches').forEach(function(swWrap){
          const productKey = swWrap.getAttribute('data-product');
          const items = productKey === 'hat' ? hatSw : kitSw;

          renderSwatches(swWrap, items);

          const def = getDefaultValue(items);
          if (def){
            swWrap.setAttribute('data-selected', def);
            setActiveSwatch(swWrap, def);
          }

          swWrap.addEventListener('click', function(e){
            const btn = e.target.closest('.kcbc__swatch');
            if (!btn) return;
            const val = btn.getAttribute('data-swatch-value');
            if (!val) return;
            swWrap.setAttribute('data-selected', val);
            setActiveSwatch(swWrap, val);

            const note = slide.querySelector('[data-kcbc-note]');
            if (note) note.textContent = '';
          });
        });

        const cartBtn = slide.querySelector('[data-kcbc-cart-cta]');
        const buyBtn = slide.querySelector('[data-kcbc-buy-cta]');
        const note = slide.querySelector('[data-kcbc-note]');

        function handleBuyNow(){
          const res = collectItems(slide);
          // Require every chosen slot to resolve — never check out a partial bundle.
          if (!res.items.length || res.unresolved > 0){
            if (note) note.textContent = i18n.selectVariants || '';
            return;
          }
          const url = buildCheckoutUrl(res.items);
          if (!url){
            if (note) note.textContent = i18n.selectVariants || '';
            return;
          }
          window.location.href = url;
        }

        function handleAddToCart(){
          const res = collectItems(slide);
          // Require every chosen slot to resolve — never add just one item of a bundle.
          if (!res.items.length || res.unresolved > 0){
            if (note) note.textContent = i18n.selectVariants || '';
            return;
          }

          if (note) note.textContent = '';

          addItemsAjax(res.items)
            .then(function(){
              openCartUI();
            })
            .catch(function(){
              if (note) note.textContent = i18n.addError || '';
            });
        }

        if (cartBtn){
          cartBtn.addEventListener('click', function(){
            handleAddToCart();
          });
        }

        if (buyBtn){
          buyBtn.addEventListener('click', function(){
            handleBuyNow();
          });
        }
      });
    
  }
  function kcbcBoot() {
    document.querySelectorAll('[id^="kcbc-"]').forEach(initKcbc);
  }
  kcbcBoot();
  document.addEventListener('shopify:section:load', kcbcBoot);
})();
